<template>
    <g v-if="show">
        <polygon :points="polygonPoints" :class="ColorMap[color].fill" fill-opacity="0.07"></polygon>
        <line :x1="x1" :y1="tween.y1" :x2="x2" :y2="tween.y2" :class="ColorMap[color].stroke" stroke-width="1"></line>
    </g>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import {Color, ColorMap} from "../types";
    import {useKerncijfersStore} from "../store";
    import tweenValue from "../../../../../lib/Tween";

    export default defineComponent({
        name: 'chart-segment',
        props: {
            valStart: {
                type: Number,
                required: true
            },
            valEnd: {
                type: Number,
                required: true
            },
            year: {
                type: Number,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            color: String
        },
        data() {
            return {
                tween: {
                    y1: 0,
                    y2: 0
                },
                Color,
                ColorMap,
                kerncijfersStore: useKerncijfersStore()
            };
        },
        watch: {
            y1(v: number) {
                tweenValue(this.tween, "y1", v);
            },
            y2(v: number) {
                tweenValue(this.tween, 'y2', v);
            }
        },
        computed: {
            show(): boolean {
                return !isNaN(this.valStart) && !isNaN(this.valEnd);
            },
            x1(): number { return this.kerncijfersStore.valueToXPos(this.index)},
            x2(): number { return this.kerncijfersStore.valueToXPos(this.index + 1) },
            x3(): number { return this.x2 },
            x4(): number { return this.x1 },
            y1(): number { return this.kerncijfersStore.valueToYPos(this.valStart) },
            y2(): number { return this.kerncijfersStore.valueToYPos(this.valEnd) },
            y3(): number { return this.kerncijfersStore.valueToYPos(0) },
            y4(): number { return this.y3 },
            polygonPoints(): string {
                return `${this.x1},${this.tween.y1} ${this.x2},${this.tween.y2} ${this.x3},${this.y3} ${this.x4},${this.y4}`
            }
        },
        mounted() {
            this.tween.y1 = this.y1;
            this.tween.y2 = this.y2;
        }
    });
    
</script>